// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class FlattenedCallCard_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.FlattenedCallCard';
  $t: string = 'SagaSchema.FlattenedCallCard';

  public static GetMembers(): string[] {
    return ['FlattenedData', 'ObjGuid', 'StartDateUtc', 'EndDateUtc', 'CallcardUid', 'FileExtension'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return FlattenedCallCard_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.StartDateUtc = this.StartDateUtc && new Date(this.StartDateUtc);
    this.EndDateUtc = this.EndDateUtc && new Date(this.EndDateUtc);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public FlattenedData: any[];
  public ObjGuid: Guid = GuidTools.Empty;
  public StartDateUtc: Date = new Date();
  public EndDateUtc: Date = new Date();
  public CallcardUid: Guid = GuidTools.Empty;
  public FileExtension: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.ObjGuid;
  }
  get ParentObjId(): any {
    return this.ObjGuid;
  }
  set ParentObjId(value: any) {
    this.ObjGuid = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
